var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fullscreen-notification-layout',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("外部ブラウザを開きます")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }